import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EKpiBasicInformationFields = {
	status: 'status',
	ruleName: 'ruleName',
	severity: 'severity',
	ruleDescription: 'ruleDescription',
} as const;

export type TKpiBasicInformationFields = TValueOfStringRecord<typeof EKpiBasicInformationFields>
